/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const arrowDown = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="m16.5 13.5-3.7 3.7V4h-1.5v13.2l-3.8-3.7-1 1 5.5 5.6 5.5-5.6z" />
	</SVG>
);

export default arrowDown;
